import { MdOndemandVideo, MdTimer } from "react-icons/md";

export default function MentorApplicationStepOne({ setApplicationState, applicationPiece }) {
  return (
    <div className="mentor-app-content">
      <h1 style={{ marginBlockEnd: "50px" }}>First, let's find out what type of course you're making.</h1>
      <div style={{display:"flex", flexWrap:"wrap", gap:"24px"}}>
        <div style={{ outline: applicationPiece.chosenCourseType === "course" ? "3px solid black" : "" }} className="mentor-app-card" onClick={() => { setApplicationState(prev => ({ ...prev, stepOne: { chosenCourseType: "course" } })) }}>
          <MdOndemandVideo size={32} />
          <p style={{ marginTop: "20px", marginBlockEnd: "8px", fontSize: "18px", fontWeight: "500" }}>Course</p>
          <p style={{ fontWeight: "300" }}>Create a rich learning experience with the help of video lectures, quizzes, assignments etc. </p>
        </div>
        <div style={{ outline: applicationPiece.chosenCourseType === "mocktest" ? "3px solid black" : "" }} className="mentor-app-card" onClick={() => { setApplicationState(prev => ({ ...prev, stepOne: { chosenCourseType: "mocktest" } })) }}>
          <MdTimer size={32} />
          <p style={{ marginTop: "20px", marginBlockEnd: "8px", fontSize: "18px", fontWeight: "500" }}>Mock Test</p>
          <p style={{ fontWeight: "300" }}>Create a mock test or a quiz for a particular topic etc. </p>
        </div>
      </div>
    </div>
  )
}